var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-title",class:{ 'pt-10 pb-5': !_vm.disablePadding}},[_vm._v(" "+_vm._s(_vm.capitalize(_vm.title))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }